/**
 * ECharts module registration.
 *
 * Registers only the chart types and components used by Stream. Import this
 * module once at app entry to initialize ECharts before any chart renders.
 *
 * Per `STREAM_VISUALIZATION.md §1.2`, we register all modules the platform
 * actively uses. Tree-shaking keeps the final bundle manageable (~200KB gzip).
 */

import * as echarts from 'echarts/core'

// Chart types
import {
  LineChart,
  BarChart,
  HeatmapChart,
  ScatterChart,
  TreemapChart,
  SunburstChart,
  SankeyChart,
  GraphChart,
  GaugeChart,
  FunnelChart,
  RadarChart,
  BoxplotChart,
  CandlestickChart,
  CustomChart,
} from 'echarts/charts'

// Components
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  BrushComponent,
  ToolboxComponent,
  MarkLineComponent,
  MarkAreaComponent,
  VisualMapComponent,
  TimelineComponent,
  CalendarComponent,
  AriaComponent,
} from 'echarts/components'

// Renderers
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers'

// Register all modules
echarts.use([
  // Chart types
  LineChart,
  BarChart,
  HeatmapChart,
  ScatterChart,
  TreemapChart,
  SunburstChart,
  SankeyChart,
  GraphChart,
  GaugeChart,
  FunnelChart,
  RadarChart,
  BoxplotChart,
  CandlestickChart,
  CustomChart,
  // Components
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  BrushComponent,
  ToolboxComponent,
  MarkLineComponent,
  MarkAreaComponent,
  VisualMapComponent,
  TimelineComponent,
  CalendarComponent,
  AriaComponent,
  // Renderers
  CanvasRenderer,
  SVGRenderer,
])

export { echarts }
